<script>

    import { toast } from 'bulma-toast'
    import { userStore, usersStore, modalStore } from '../stores'

    import UsersService from '../$services/users.service'

    import ButtonSave from '../$components/button.save.svelte'
    import InputText from '../$components/input.text.svelte'
    import Button from '../$components/button.svelte'
    import Form from '../$components/form.svelte'

    let loading = false
    let data = {
        location: $userStore.location || {}
    }

    async function updateUser() {

        loading = true
        const resp = await UsersService.updateUser($userStore._id, data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        userStore.set(resp.data)
        usersStore.replace(resp.data)

        toast({message: 'Usuario actualizado', type: 'is-success'})
        modalStore.close()
    }

</script>

<Form on:submit={updateUser} {loading}>

    <div class="columns">
        <div class="column">
            <InputText bind:value={data.location.contact} label="Contacto" placeholder="Ingrese contacto" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={data.location.rfc} label="RFC" placeholder="Ingrese RFC" />
        </div>
        <div class="column">
            <InputText bind:value={data.location.corporate} label="Empresa" placeholder="Ingrese empresa" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={data.location.phone} label="Teléfono" placeholder="Ingrese teléfono" />
        </div>
        <div class="column">
            <InputText bind:value={data.location.email} label="Correo" placeholder="Ingrese correo" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={data.location.zipcode} label="Código postal" placeholder="Ingrese código postal" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={data.location.state} label="Estado" placeholder="Ingrese estado" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={data.location.city} label="Ciudad" placeholder="Ingrese ciudad" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={data.location.municipality} label="Municipio" placeholder="Ingrese municipio" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={data.location.colony} label="Colonia" placeholder="Ingrese colonia" />
        </div>
        <div class="column">
            <InputText bind:value={data.location.street} label="Calle" placeholder="Ingrese calle" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={data.location.number} label="Exterior" placeholder="Ingrese contacto" />
        </div>
        <div class="column">
            <InputText bind:value={data.location.apartment} label="Interior" placeholder="Ingrese interior" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={data.location.references} label="Referencias" placeholder="Ingrese referencias" />
        </div>
    </div>

    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <Button on:click={modalStore.close} text="Cancelar" icon="ban" />
        <ButtonSave icon="edit" text="Actualizar" />
    </div>

</Form>